module.exports = __webpack_public_path__ + "img/del.38037c73.svg";